const FieldType = {
  EMAIL: "email",
  DATE: "date",
  TEXT: "string",
  BOOLEAN: "boolean",
};

export default FieldType;
